module.exports = __webpack_public_path__ + "img/premio-03.885ffd6b.png";